// @core/api/endpoints/payment/update_payment_type.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PaymentTypeDefinitionResponse,
  UpdatePaymentTypeRequest,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Update payment type
 * Updates a payment type definition (default currency, retry behavior, receipt config, allowed methods).
 */
export async function UpdatePaymentType(
  type_id: string,
  data: UpdatePaymentTypeRequest,
  options?: RequestOptions
): Promise<PaymentTypeDefinitionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/payment-types/:type_id`;
  requestPath = requestPath.replace(':type_id', encodeURIComponent(type_id));
  const requestOptions = options;
  return client.put<PaymentTypeDefinitionResponse>(requestPath, data, requestOptions);
}
